/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { StationConfigGetQueryResponse, StationConfigGetPathParams } from "../models/StationConfigGet";

export function getStationConfigGetUrl(stationId: StationConfigGetPathParams["stationId"]) {
  const res = { method: 'GET', url: `/station-config/${stationId}` as const }  
  return res
}

/**
 * @summary Get station config for client user
 * {@link /station-config/:stationId}
 */
export async function stationConfigGet(stationId: StationConfigGetPathParams["stationId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<StationConfigGetQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStationConfigGetUrl(stationId).url.toString(), ... requestConfig })  
  return res.data
}